export const RESET_TIMER = 'RESET_TIMER';